import { render } from "./PrintHeaderDesign1.vue?vue&type=template&id=530822aa&scoped=true"
import script from "./PrintHeaderDesign1.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign1.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign1.vue?vue&type=style&index=0&id=530822aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530822aa"]])

export default __exports__